import { nevelos } from '@ertekbecslo/kozos/szoveg';
import { aranySzoveg } from './valtozas.ts';

/** A Weboldal oldal olvasó blokkjának fő mondata; `kozeliNev` a tű legközelebbi területe (ha ismert). */
export function korzetMondat(sugarKm: number | null, kozeliNev: string | null): string {
  if (sugarKm === null) return 'Az oldal minden címről fogad becslést.';
  return kozeliNev
    ? `A becslés ${nevelos(kozeliNev)} körüli ${sugarKm} km-es körzetben érhető el.`
    : `A becslés a megadott pont körüli ${sugarKm} km-es körzetben érhető el.`;
}

/** Az Elemzés blokk arány-mondata; null aránynál (nincs kérés) üres. */
export function korzetAranyMondat(arany: number | null): string {
  return arany === null ? '' : `A becslést indítók ${aranySzoveg(arany)}-a esett a körzeten kívül.`;
}

export const KORZET_URES_SZOVEG = 'Az időszakban nem volt körzeten kívüli kérés.';
